import util from '../util'

let controller = 'ParceiroNotificacao'
export default Object.assign({}, util.GetCrud(controller, null))